// extracted by mini-css-extract-plugin
module.exports = {"main":"umZrykE5hRsVquN1DW_f8","flexible":"xl9ZLDu32LAjrDqSsv5Gj"};